import { render, staticRenderFns } from "./DialogSplitHelperInfo.vue?vue&type=template&id=af7e7296&scoped=true"
import script from "./DialogSplitHelperInfo.js?vue&type=script&lang=js&external"
export * from "./DialogSplitHelperInfo.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7e7296",
  null
  
)

export default component.exports